/**
 * Returns an array with a value that you can conditionally spread onto another array.
 * The returned array will only include the provided `value` if `condition` is true.
 *
 * @example ["a", ...spreadIf(false, "b"), ...spreadIf(true, "c")] // evaluates to ["a", "c"]
 */
export function spreadIf<T>(condition: boolean, value: T): [T] | [] {
  return condition ? [value] : [];
}
